import { useState, useEffect } from "react";
import "../../assets/css/loginModal.css";
import api from "../../shared/utils/request";
import { Toaster, toast } from "react-hot-toast";

const LoginModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    } else if (timer === 0 && step === 2) {
      setCanResend(true);
    }
  }, [timer, step]);

  const handleSendOTP = async (e) => {
    e.preventDefault();
    if (phone.length === 10) {
      setLoading(true);
      try {
        const data = await api.post(`customer/send-otp`, {
          mobile: `${phone}`,
        });
        if (data?.status === true) {
          // alert("Your OTP is : " + data?.otp);
          setStep(2);
          setTimer(60);
          setCanResend(false);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch product details:", error);
      }
    }
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      setLoading(true);
      try {
        const data = await api.post(`customer/verify-otp`, {
          mobile: `${phone}`,
          otp: otpValue,
          fcm_token: window.fcmToken || undefined,
        });
        if (data?.status === true) {
          localStorage.setItem("token", data?.token);
          localStorage.setItem("user", JSON.stringify(data?.user));
          window.location.reload();
        } else {
          toast.error(data?.message || "Invalid OTP");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Verification failed. Please try again.");
        console.error("Failed to fetch product details:", error);
      }
    }
  };

  const handleResendOTP = (event) => {
    if (canResend) {
      handleSendOTP(event);
      setTimer(60);
      setCanResend(false);
      setOtp(["", "", "", "", "", ""]);
    }
  };

  const handleClose = () => {
    setStep(1);
    setPhone("");
    setOtp(["", "", "", "", "", ""]);
    setTimer(0);
    setCanResend(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={handleClose}>
      <Toaster position="top-center" />
      <div
        className="login-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="login-modal-close" onClick={handleClose}>
          <i className="ph ph-x" />
        </button>

        <div className="login-modal-content">
          <div className="login-modal-icon">
            <i className="ph ph-lock-key" />
          </div>

          <h2 className="login-modal-title">
            {step === 1 ? "Welcome Back!" : "Verify OTP"}
          </h2>
          <p className="login-modal-subtitle">
            {step === 1
              ? "Enter your phone number to continue"
              : `We've sent a code to +91 ${phone}`}
          </p>

          {step === 1 ? (
            <form onSubmit={handleSendOTP} className="login-modal-form">
              <div className="login-input-group">
                <div className="login-input-wrapper">
                  <span className="login-input-prefix">+91</span>
                  <input
                    type="tel"
                    className="login-input"
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
                    }
                    maxLength="10"
                    required
                  />
                </div>
              </div>
              <button
                type="submit"
                className="login-btn"
                disabled={phone.length !== 10 || loading}
              >
                {loading ? "Sending..." : "Send OTP"}
                {loading ? (
                  <i className="ph ph-spinner" />
                ) : (
                  <i className="ph ph-arrow-right" />
                )}
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP} className="login-modal-form">
              <div className="otp-input-group">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    className="otp-input"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    maxLength="1"
                    inputMode="numeric"
                  />
                ))}
              </div>

              <div className="login-timer-section">
                {timer > 0 ? (
                  <p className="login-timer">
                    <i className="ph ph-clock" /> Resend OTP in{" "}
                    <span>{timer}s</span>
                  </p>
                ) : (
                  <button
                    type="button"
                    className="login-resend-btn"
                    onClick={handleResendOTP}
                  >
                    <i className="ph ph-arrow-clockwise" /> Resend OTP
                  </button>
                )}
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={otp.join("").length !== 6 || loading}
              >
                {loading ? "Verifying..." : "Verify & Continue"}
                {loading ? (
                  <i className="ph ph-spinner" />
                ) : (
                  <i className="ph ph-check-circle" />
                )}
              </button>

              <button
                type="button"
                className="login-back-btn"
                onClick={() => {
                  setStep(1);
                  setOtp(["", "", "", "", "", ""]);
                  setTimer(0);
                }}
              >
                <i className="ph ph-arrow-left" /> Change Number
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
